export default __webpack_public_path__ + "static/defaultVehicle-3a480c5bf36ccfd635f941f23e67a180.webp";